import {useContext, useRef} from "react"
import styles from "./VoiceCallPanel.module.css"
import {VoiceCallContext} from "context/VoiceCallContext"
import Draggable from "react-draggable"
import {UserAvatar} from "sections/NewCommunication/shared"
import cx from "classnames"
import {ReactComponent as DialerIcon} from "./assets/dialer.svg"
import {BASE_DEPARTMENT_NAME} from "types/departments"
import {Settings} from "types/settings"

export function VoiceCallPanel() {
    const {
        calling,
        activeStudent,
        callStatus,
        isConnected,
        hangup,
        queuedStudents,
        isAuto,
        activeDepartmentId,
        voiceProvider
    } = useContext(VoiceCallContext)
    const containerRef = useRef<HTMLDivElement>(null)

    if ((queuedStudents.length === 0 && !calling) || !activeStudent) return null

    const nextStudent = queuedStudents?.[0]
    const isInTransitionCall = !!nextStudent && callStatus === "ended"

    return (
        <Draggable bounds="parent" nodeRef={containerRef}>
            <div ref={containerRef} className={styles.containerWrap}>
                <div className={styles.container}>
                    <div className={styles.callContainer}>
                        <UserAvatar user={activeStudent} className={styles.avatar} />
                        {isAuto ? <div className={styles.autoContainer}>Auto</div> : <div />}
                    </div>
                    {isInTransitionCall ? (
                        <span className={styles.status}>next call in 10s</span>
                    ) : (
                        <div className={styles.info}>
                            {activeDepartmentId ? (
                                <div className={styles.departmentContainer}>
                                    {BASE_DEPARTMENT_NAME[activeDepartmentId]}
                                </div>
                            ) : (
                                <div />
                            )}
                            <span className={styles.name}>{activeStudent.fullName}</span>
                            <span className={styles.phone}>{activeStudent.phone}</span>
                            <span className={styles.status}>{callStatus}...</span>
                        </div>
                    )}
                    {isConnected && voiceProvider !== Settings.DialerProvider.Zoom && (
                        <div
                            className={cx(styles.btnWrap, {[styles.btnHangup]: isConnected})}
                            onClick={() => isConnected && hangup()}>
                            <DialerIcon className={styles.icon} />
                            <span className={styles.title}>Hang Up</span>
                        </div>
                    )}
                    {!isInTransitionCall && nextStudent && (
                        <div className={styles.nextContainer}>
                            <span className={styles.nextTitle}>Next: </span>
                            <span className={styles.nextStudent}>{nextStudent.fullName}</span>
                            <span className={styles.nextPhone}>{nextStudent.phone}</span>
                        </div>
                    )}
                </div>
            </div>
        </Draggable>
    )
}
